// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uzimcnouitbynnmwndni.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV6aW1jbm91aXRieW5ubXduZG5pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEzMDkzNTQsImV4cCI6MjA4Njg4NTM1NH0.OgD9D4-KgcQ2vKhUN_Z8UesSdQUkjwa-nHRcKndNCjI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    flowType: "implicit",     // magic links must work across browsers/email clients
    detectSessionInUrl: true, // auto-process auth code on callback
  }
});